export function FloatRoundingFilter() {
    return function(input) {
        return input.toFixed(1);
    };
}
